// extracted by mini-css-extract-plugin
export default {"cardContainer":"buyCrypto_cardContainer__6GupP","iconsContainer":"buyCrypto_iconsContainer__5iKic"};